import { AlertCircle, Clock, Target, Wallet } from "lucide-react";

const problems = [
  { icon: Target, title: "No clarity on where AI fits", desc: "Teams chase trends instead of identifying where AI will produce measurable business outcomes." },
  { icon: Wallet, title: "Heavy upfront investment", desc: "Most AI initiatives commit budget before validating whether ROI actually exists." },
  { icon: Clock, title: "Long pilots, weak outcomes", desc: "Months are spent on proofs-of-concept that never reach measurable impact." },
  { icon: AlertCircle, title: "Readiness gaps go unseen", desc: "Data, workflows, and team capacity issues are discovered only after the spend." },
];

const Problem = () => {
  return (
    <section className="py-12 lg:py-14">
      <div className="container-tight">
        <div className="max-w-3xl">
          <span className="eyebrow">The problem</span>
          <h2 className="mt-4 text-3xl font-semibold tracking-tight text-foreground sm:text-4xl lg:text-5xl">
            Most AI initiatives fail before they begin.
          </h2>
          <p className="mt-5 text-lg text-muted-foreground">
            Not because the technology doesn't work but because organizations commit before knowing whether ROI is even achievable.
          </p>
        </div>

        <div className="mt-14 grid gap-5 sm:grid-cols-2">
          {problems.map(({ icon: Icon, title, desc }) => (
            <div key={title} className="rounded-2xl border border-border bg-card p-6 shadow-soft transition-shadow hover:shadow-card">
              <div className="flex h-10 w-10 items-center justify-center rounded-lg bg-secondary">
                <Icon className="h-5 w-5 text-foreground" strokeWidth={1.75} />
              </div>
              <h3 className="mt-5 text-lg font-semibold text-foreground">{title}</h3>
              <p className="mt-2 text-sm leading-relaxed text-muted-foreground">{desc}</p>
            </div>
          ))}
        </div>

        <p className="mt-10 max-w-2xl text-base text-muted-foreground">
          This is exactly where <span className="font-medium text-foreground">starting small with clarity</span> becomes critical.
        </p>
      </div>
    </section>
  );
};

export default Problem;
